export class SearchFiltersFacetQuery {
  public facetQuery: string;
  public value: string;

  constructor(obj: SearchFiltersFacetQuery) {
    this.facetQuery = obj.facetQuery || '';
    this.value = obj.value || 'true';
  }
}
